import { memo } from 'react';
import { Input as InputAnt, InputProps } from 'antd';

const Input: React.FC<InputProps> = ({ ...props }) => {
  return <InputAnt {...props} />;
};

export default memo(Input);
